function usePreventTransitionInteraction({ open }) {
  const onKeyDownCapture = (e) => {
    if (!open) {
      e.preventDefault();
    }
  };
  const style = open ? void 0 : {
    pointerEvents: "none"
  };
  return {
    style,
    onKeyDownCapture
  };
}

export { usePreventTransitionInteraction };
//# sourceMappingURL=usePreventTransitionInteraction.mjs.map
